export default {
    getPatientWaitingTableIsShow: state => state.patientWaitingTableIsShow,
    getPatientWaitingDisbandIsShow: state => state.patientWaitingDisbandIsShow,
    getPatientAttendanceWrapperIsShow: state => state.patientAttendanceTableIsShow,
    getPatientAttendanceDetailsIsShow: state => state.patientAttendanceDetailsIsShow,
    getOccupationHealthDoctorAppointmentIsShow: state => state.occupationHealthDoctorAppointmentIsShow,

    getPatientWaitingTableRowActions: state => state.patientWaitingTableRowActions,
    getPatientWaitingTableAdditionalConfig: state => state.patientWaitingTableAdditionalConfig,
    getPatientWaitingTableAppointmentRowActions: state => state.patientWaitingTableAppointmentRowActions,
    getPatientWaitingTableHeaderFields: state => state.patientWaitingTableHeaderFields
}
